/* Linked colour swatches (snippets/sk-colour-links.liquid).
   Without JS the swatches are plain links. With JS:
   - the selected size carries over: the link opens the same size (all size options) in the other colour when it is in stock;
   - hovering or focusing a swatch previews its colour name in the label. */
(function () {
  // Selected non-colour options in option order, joined like the size map keys: "M" or "M / D3"
  function selectedSize(box) {
    var list = (box.getAttribute('data-size-positions') || '').split(',').filter(Boolean);
    var wrap = document.querySelector('.product__variants-swatches[data-section="' + box.getAttribute('data-section') + '"]');
    if (!wrap || !list.length) return null;
    var parts = [];
    for (var i = 0; i < list.length; i++) {
      var checked = wrap.querySelector('.swatches__container[data-option-index="' + list[i] + '"] input[type=radio]:checked');
      if (!checked) return null;
      parts.push(checked.value);
    }
    return parts.join(' / ');
  }
  function init(box) {
    if (box.__skColourLinks) return;
    box.__skColourLinks = true;
    var name = box.querySelector('[data-sk-colour-name]');
    var current = name ? name.textContent : '';
    box.querySelectorAll('.sk-colour-links__swatch').forEach(function (a) {
      var base = a.getAttribute('href').split('?')[0];
      function withSize() {
        if (a.classList.contains('is-current')) return;
        var size = selectedSize(box), sizes = {};
        try { sizes = JSON.parse(a.getAttribute('data-sizes') || '{}'); } catch (e) {}
        a.setAttribute('href', size && sizes[size] ? base + '?variant=' + sizes[size] : base);
      }
      function preview() { if (name) name.textContent = a.getAttribute('data-label'); }
      function restore() { if (name) name.textContent = current; }
      a.addEventListener('pointerenter', function () { preview(); withSize(); });
      a.addEventListener('pointerleave', restore);
      a.addEventListener('focus', function () { preview(); withSize(); });
      a.addEventListener('blur', restore);
      a.addEventListener('pointerdown', withSize);
      a.addEventListener('click', withSize);
    });
  }
  function run() { document.querySelectorAll('[data-sk-colour-links]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
